<template>
  <div name="hrms13x-detail">
    <div  class="box">
      <div class="box-body">
        <div class="detail detail-responsive">
          <div class="clearfix detail-row">
            <div class="detail-left">{{ labels['HRPM81X2']['10'] }}</div>
            <div class="detail-right">
                <div class="detail-text width-100">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion"> 

        <detail-tab1 :labels="labels"
                     :data="detail.tab1" />
    
        <detail-tab2 :labels="labels"
                     :data="detail.tab2"
                     :tab2Table="tab2Table" />
 
        <detail-tab3 :labels="labels"
                     :data="detail.tab3"
                     :tab3Table1="tab3Table1"
                     :tab3Table2="tab3Table2" />

        <detail-tab4 :labels="labels"
                     :data="detail.tab4"
                     :tab4Table="tab4Table" />

        <detail-tab5 :labels="labels"
                     :data="detail.tab5"
                     :indexSelected="indexSelected"
                     :nowLang="nowLang" />


        <div class="box-footer">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import detailTab1 from 'components/hrms13x/detailTab1'
import detailTab2 from 'components/hrms13x/detailTab2'
import detailTab3 from 'components/hrms13x/detailTab3'
import detailTab4 from 'components/hrms13x/detailTab4'
import detailTab5 from 'components/hrms13x/detailTab5'

export default {
  name: 'hrms13x-detail',
  props: [ 'labels',
    'labelsButton',
    'detail',
    'nowLang',
    'toggle',
    'indexSelected',
    'tab2Table',
    'tab3Table1',
    'tab3Table2',
    'tab4Table'
  ],
  components: {
    detailTab1,
    detailTab2,
    detailTab3,
    detailTab4,
    detailTab5
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?406abb88